<dashboard-toolbar-part class="toolbar"></dashboard-toolbar-part>
<quick-filters-bar-part></quick-filters-bar-part>

<div class="main-content">
	<div class="display">
		<div class="display-scaler">
			<vega-part></vega-part>
		</div>
	</div>
	<quick-filters-panel-part></quick-filters-panel-part>
</div>